package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2025_04_12_Day_1() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("We return to our heroes who had just arrived at the guest hut in Banshir. As promised, Elder Dary Darusha soon arrives with a number of townsfolk. He introduces the townsfolk: Dary Darusha, Jak and Beeta Kadola, Triss Zorjika, and Aseera Overdale. Korvis introduces the heroes. Tuesday flies around the room to impress the visitors. The townsfolk are worried about Slaad.")
    }
}
